"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trace = exports.makeTrace = void 0;
const tslib_1 = require("tslib");
const debug_1 = tslib_1.__importDefault(require("debug"));
function makeTrace(ns) {
    const debug = (0, debug_1.default)(ns);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (obj, ...values) => {
        let text;
        if (typeof obj === 'string') {
            text = obj;
        }
        else {
            const { msg, ...rest } = obj;
            text = (msg || '') + ' %O';
            values.push(rest);
        }
        debug(text, ...values);
    };
}
exports.makeTrace = makeTrace;
exports.trace = makeTrace('trace');
//# sourceMappingURL=trace.js.map